import LoadingSpinner from '@/components/CustomComponent/LoadingSpinner';
import { COMMON_TEXT } from '@/helpers/common-text';
import {
  API_KEY_PRODUCT_TYPE,
  QUERY_STRING_STORE,
  TENANT_SCHEDULE_TOOL_TYPE,
} from '@/helpers/constants';
import {
  getConfigurationUrlWithParam,
  randomStringWithSymbol,
} from '@/helpers/utility';
import { createAuthenticatedApiClient } from 'src/helpers/api-client';
import { WorkflowsApi } from '@/openapi/apis/WorkflowsApi';
import { Form, Formik } from 'formik';
import { cloneDeep, isEmpty, isEqual, isNil, isNull } from 'lodash';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Password } from 'primereact/password';
import { RadioButton } from 'primereact/radiobutton';
import { Toast } from 'primereact/toast';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import {
  fetchApiKeyByTenantId,
  fetchTenantById,
  fetchAuthProviderById,
} from './query-request';
import Toaster from 'src/components/CustomComponent/Toaster';
import SaveButton from 'src/components/CustomComponent/SaveButton/SaveButton';

@connect(state => ({
  tenantId: state.querystring?.['select-tenant']?.[0],
  querystring: state.querystring,
  sessionStore: state.session,
}))
class TenantSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0],
      isLoading: false,
      initialFormValues: {
        tenantId: null,
        tenantName: '',
        scheduleTool: '',
        shorteningMeeting: 0,
        merakiApiKeyId: null,
        merakiApiKey: null,
        verkadaApiKeyId: null,
        verkadaApiKey: null,
        microsoftApiKeyId: null,
        microsoftApiKey: null,
        microsoftGraphClientId: null,
        microsoftGraphTenantId: null,
        microsoftTeamsWebhookUrl: null,
        butlrUsername: null,
        butlrApiKey: null,
        slackApiKey: null,
        arubaApiKey: null,
        arubaRefreshToken: null,
        arubaClientSecret: null,
        arubaClientId: null,
        garoonUsername: null,
        garoonApiKey: null,
        garoonSubdomain: null,
        webexApiKey: null,
        webexRefreshToken: null,
        webexClientId: null,
        webexClientSecret: null,
        authProviderId: null,
        authProvider: '',
        azureTenantId: '',
        azureClientId: '',
        azureClientSecret: '',
        ipRestrictionEnabled: false,
        allowedIps: '',
        isPasswordLogin: true,
      },
      originalFormValues: null,
      hasIpError: false,
    };
    this.secretString = `THIS_IS_JUST_RANDOM_${randomStringWithSymbol(20)}`;
    this.toastRef = React.createRef();
    this.merakiFieldList = [
      {
        key: 'merakiApiKey',
        respondKey: 'apikey',
        payloadKey: 'key',
        title: COMMON_TEXT.API_KEY,
        isMasked: true,
        hasApiKey: 0,
      },
    ];
    this.verkadaFieldList = [
      {
        key: 'verkadaApiKey',
        respondKey: 'apikey',
        payloadKey: 'key',
        title: COMMON_TEXT.API_KEY,
        isMasked: true,
        hasApiKey: 0,
      },
    ];
    this.microsoftOfficeFieldList = [
      {
        key: 'microsoftApiKey',
        respondKey: 'apikey',
        payloadKey: 'key',
        title: COMMON_TEXT.MICROSOFT_API_KEY,
        isMasked: true,
        hasApiKey: 0,
      },
      {
        key: 'microsoftGraphClientId',
        respondKey: 'graph_client_id',
        title: COMMON_TEXT.MICROSOFT_GRAPH_CLIENT_ID,
      },
      {
        key: 'microsoftGraphTenantId',
        respondKey: 'graph_tenant_id',
        title: COMMON_TEXT.MICROSOFT_GRAPH_TENANT_ID,
      },
    ];
    this.microsoftTeamsFieldList = [
      {
        key: 'teamsWebhookUrl',
        respondKey: 'webhook_url',
        payloadKey: 'webhook_url',
        title: COMMON_TEXT.WEBHOOK_URL,
        isMasked: false,
      },
    ];
    this.googleFieldList = [
      {
        key: 'googleApiKey',
        respondKey: 'apikey',
        payloadKey: 'key',
        title: COMMON_TEXT.GOOGLE_API_KEY,
        isMasked: true,
        hasApiKey: 0,
      },
      {
        key: 'googleUsername',
        respondKey: 'username',
        title: COMMON_TEXT.GOOGLE_USERNAME,
      },
    ];
    this.butlrFieldList = [
      {
        key: 'butlrUsername',
        respondKey: 'username',
        title: COMMON_TEXT.BUTLR_USERNAME,
      },
      {
        key: 'butlrApiKey',
        respondKey: 'apikey',
        payloadKey: 'key',
        title: COMMON_TEXT.BUTLR_API_KEY,
        isMasked: true,
      },
    ];
    this.slackFieldList = [
      {
        key: 'slackApiKey',
        respondKey: 'apikey',
        payloadKey: 'key',
        title: COMMON_TEXT.TOKEN,
        isMasked: true,
        hasApiKey: 0,
      },
    ];

    this.arubaFieldList = [
      {
        key: 'arubaApiKey',
        respondKey: 'apikey',
        payloadKey: 'key',
        title: COMMON_TEXT.ARUBA_API_KEY,
        isMasked: true,
        hasApiKey: 0,
      },
      {
        key: 'arubaRefreshToken',
        respondKey: 'refresh_token',
        payloadKey: 'refresh_token',
        title: COMMON_TEXT.ARUBA_REFRESH_TOKEN,
        isMasked: true,
        hasRefreshToken: 0,
      },
      {
        key: 'arubaClientSecret',
        respondKey: 'client_secret',
        payloadKey: 'client_secret',
        title: COMMON_TEXT.ARUBA_CLIENT_SECRET,
        isMasked: true,
        hasClientSecret: 0,
      },
      {
        key: 'arubaClientId',
        respondKey: 'client_id',
        payloadKey: 'client_id',
        title: COMMON_TEXT.ARUBA_CLIENT_ID,
      },
    ];

    this.garoonFieldList = [
      {
        key: 'garoonUsername',
        respondKey: 'username',
        title: COMMON_TEXT.GAROON_USERNAME,
      },
      {
        key: 'garoonApiKey',
        respondKey: 'apikey',
        payloadKey: 'key',
        title: COMMON_TEXT.GAROON_API_KEY,
        isMasked: true,
        hasApiKey: 0,
      },
      {
        key: 'garoonSubdomain',
        respondKey: 'subdomain',
        title: COMMON_TEXT.GAROON_SUBDOMAIN,
      },
    ];
    this.webexFieldList = [
      {
        key: 'webexApiKey',
        respondKey: 'apikey',
        payloadKey: 'key',
        title: COMMON_TEXT.WEBEX_API_KEY,
        isMasked: true,
        hasApiKey: 0,
      },
      {
        key: 'webexRefreshToken',
        respondKey: 'refresh_token',
        title: COMMON_TEXT.WEBEX_REFRESH_TOKEN,
        isMasked: true,
        hasRefreshToken: 0,
      },
      {
        key: 'webexClientId',
        respondKey: 'client_id',
        title: COMMON_TEXT.WEBEX_CLIENT_ID,
      },
      {
        key: 'webexClientSecret',
        respondKey: 'client_secret',
        title: COMMON_TEXT.WEBEX_CLIENT_SECRET,
        hasClientSecret: 0,
        isMasked: true,
      },
    ];
    this.scheduleToolOptions = [
      {
        label: 'Microsoft Office',
        value: TENANT_SCHEDULE_TOOL_TYPE.MICROSOFT,
      },
      {
        label: 'Google Workspace',
        value: TENANT_SCHEDULE_TOOL_TYPE.GOOGLE,
      },
      {
        label: 'Garoon',
        value: TENANT_SCHEDULE_TOOL_TYPE.GAROON,
      },
      {
        label: 'なし',
        value: '',
      },
    ];
    this.passwordLoginOptions = [
      {
        label: '有効',
        value: true,
      },
      {
        label: '無効',
        value: false,
      },
    ];
    this.passwordLoginOptions = [
      {
        label: '有効',
        value: true,
      },
      {
        label: '無効',
        value: false,
      },
    ];
    this.shortMeetingOptions = [
      {
        label: '有効',
        value: 1,
      },
      {
        label: '無効',
        value: 0,
      },
    ];
    this.authProviderOptions = [
      {
        label: 'Microsoft Azure',
        value: 'azure',
      },
      {
        label: '無効',
        value: 'none',
      },
    ];
  }

  componentDidMount() {
    const { tenant } = this.state;
    if (tenant) {
      this.setState({ tenant }, () => {
        this.getData();
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { querystring } = this.props;
    const { querystring: prevQuerystring } = prevProps;
    const tenant = querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const prevTenant =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const isTenantChanged = tenant !== prevTenant;
    if (isTenantChanged) {
      this.setState({ tenant }, () => {
        this.getData();
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  goBackToConfigPage = () => {
    const { querystring } = this.props;
    window.location.href = getConfigurationUrlWithParam({ querystring });
  };



  convertFieldToKeyValue = ({ apiKeyList }) => {
    const result = {};
    for (const apiKeyInfo of apiKeyList) {
      const {
        apikey_id,
        product,
        has_apikey,
        has_client_secret,
        has_refresh_token,
      } = apiKeyInfo;
      result[`${product}ApiKeyId`] = apikey_id;
      result[`${product}HasApiKey`] = has_apikey;
      result[`${product}HasClientSecret`] = has_client_secret;
      result[`${product}HasRefreshToken`] = has_refresh_token;
      let fieldList = [];
      switch (product) {
        case API_KEY_PRODUCT_TYPE.MERAKI:
          fieldList = [...this.merakiFieldList];
          break;
        case API_KEY_PRODUCT_TYPE.VERKADA:
          fieldList = [...this.verkadaFieldList];
          break;
        case API_KEY_PRODUCT_TYPE.MICROSOFT_OFFICE:
          fieldList = [...this.microsoftOfficeFieldList];
          break;
        case API_KEY_PRODUCT_TYPE.MICROSOFT_TEAMS:
          fieldList = [...this.microsoftTeamsFieldList];
          break;
        case API_KEY_PRODUCT_TYPE.BUTLR:
          fieldList = [...this.butlrFieldList];
          break;
        case API_KEY_PRODUCT_TYPE.SLACK:
          fieldList = [...this.slackFieldList];
          break;
        case API_KEY_PRODUCT_TYPE.ARUBA:
          fieldList = [...this.arubaFieldList];
          break;
        case API_KEY_PRODUCT_TYPE.GAROON:
          fieldList = [...this.garoonFieldList];
          break;
        case API_KEY_PRODUCT_TYPE.WEBEX:
          fieldList = [...this.webexFieldList];
          break;
        case API_KEY_PRODUCT_TYPE.GOOGLE:
          fieldList = [...this.googleFieldList];
          break;
        default:
          break;
      }
      fieldList.forEach(item => {
        const { key, respondKey } = item;
        if (respondKey === 'apikey') {
          result['hasApiKey'] = has_apikey;
          result[key] = has_apikey > 0 ? this.secretString : '';
        } else if (respondKey === 'refresh_token') {
          result['hasRefreshToken'] = has_refresh_token;
          result[key] = has_refresh_token > 0 ? this.secretString : '';
        } else if (respondKey === 'client_secret') {
          result['hasClientSecret'] = has_client_secret;
          result[key] = has_client_secret > 0 ? this.secretString : '';
        } else {
          result[key] = apiKeyInfo[respondKey] ?? null;
        }
      });
    }
    return result;
  };

  getData = async () => {
    const { initialFormValues, tenant } = this.state;
    this.setState({ isLoading: true });
    let tenantInfo = await fetchTenantById({ tenantId: tenant });
    let updatedState = {};
    tenantInfo = tenantInfo?.[0] ?? {};
    const { tenant_name, tenant_id, schedule_tool, allowed_ips, is_password_login } = tenantInfo;

    // Handle allowed_ips: NULL → empty string, non-empty → enabled
    let allowedIpsValue = allowed_ips || '';

    // Format IPs for display: if more than 2 IPs, show line by line
    if (allowedIpsValue) {
      const ips = allowedIpsValue.split(',').map(ip => ip.trim()).filter(ip => ip);
      allowedIpsValue = ips.join('\n');
    }

    const ipRestrictionEnabled = Boolean(allowed_ips);
    // is_password_login: null or true = enabled, false = disabled
    // 0 is false, 1 is true, null is true
    const isPasswordLogin = is_password_login !== 0;

    updatedState = {
      initialFormValues: {
        ...initialFormValues,
        tenantId: tenant_id,
        tenantName: tenant_name,
        scheduleTool: schedule_tool ?? '',
        allowedIps: allowedIpsValue,
        ipRestrictionEnabled: ipRestrictionEnabled,
        isPasswordLogin: isPasswordLogin,
      },
    };

    let apiKeyList = await fetchApiKeyByTenantId({ tenantId: tenant });
    apiKeyList = apiKeyList || [];
    const keyFieldInfo = this.convertFieldToKeyValue({ apiKeyList });
    updatedState = {
      ...updatedState,
      initialFormValues: {
        ...updatedState.initialFormValues,
        ...keyFieldInfo,
      },
    };

    let authProviderInfo = await fetchAuthProviderById({ tenantId: tenant });
    authProviderInfo = authProviderInfo || [];
    authProviderInfo =
      authProviderInfo.filter(item => item.auth_provider === 'azure')?.[0] ??
      {};

    const {
      auth_provider,
      auth_provider_id,
      azure_tenant_id,
      azure_client_id,
      has_azure_client_secret,
    } = authProviderInfo;

    const isMasked = has_azure_client_secret === 1 ? true : false;

    updatedState = {
      ...updatedState,
      initialFormValues: {
        ...updatedState.initialFormValues,
        authProviderId: auth_provider_id,
        authProvider: auth_provider ? auth_provider : 'none',
        azureTenantId: azure_tenant_id ?? '',
        azureClientId: azure_client_id ?? '',
        azureClientSecret: isMasked ? this.secretString : '',
      },
      isLoading: false,
    };

    const originalFormValues = cloneDeep(updatedState.initialFormValues);
    updatedState = {
      ...updatedState,
      originalFormValues,
    };
    this.setState(updatedState);
  };

  updateTenantInfo = async ({ tenantPayload }) => {
    try {
      const workflowsApi = createAuthenticatedApiClient(WorkflowsApi);
      const updateRes = await workflowsApi.updateSettingsTenants({
        apiPostWorkflowRequest: {
          ...tenantPayload,
          tenantId: this.props.tenantId,
        }
      });

      const { success } = updateRes;
      if (!success) {
        throw Error('UPDATE SETTING ERROR');
      }
      return { isSuccess: true };
    } catch (error) {
      console.error('UPDATE SETTING ERROR', error);
    }
    return { isSuccess: false };
  };

  updateApiKeysInfo = async ({ apiKeyPayload }) => {
    try {
      const workflowsApi = createAuthenticatedApiClient(WorkflowsApi);
      const updateRes = await workflowsApi.updateSettingsApikeys({
        apiPostWorkflowRequest: {
          ...apiKeyPayload,
          tenantId: this.props.tenantId,
        }
      });

      const { success } = updateRes;
      if (!success) {
        throw Error('UPDATE SETTING ERROR');
      }
      return { isSuccess: true };
    } catch (error) {
      console.error('UPDATE SETTING ERROR', error);
    }
    return { isSuccess: false };
  };

  updateAuthProviderInfo = async ({ authProviderPayload }) => {
    try {
      const workflowsApi = createAuthenticatedApiClient(WorkflowsApi);
      const updateRes = await workflowsApi.updateSettingsAuthProviders({
        apiPostWorkflowRequest: {
          ...authProviderPayload,
          tenantId: this.props.tenantId,
        }
      });

      const { success } = updateRes;
      if (!success) {
        throw Error('UPDATE SETTING AUTH PROVIDERS ERROR');
      }
      return { isSuccess: true };
    } catch (error) {
      console.error('UPDATE SETTING AUTH PROVIDERS ERROR', error);
    }
    return { isSuccess: false };
  };

  getTenantInfoPayload = ({ data }) => {
    const { originalFormValues } = this.state;
    const {
      tenantId: originalTenantId,
      tenantName: originalTenantName,
      scheduleTool: originalScheduleTool,
      allowedIps: originalAllowedIps,
      isPasswordLogin: originalIsPasswordLogin,
    } = originalFormValues;

    const { tenantId, tenantName, scheduleTool, ipRestrictionEnabled, allowedIps, isPasswordLogin } = data;

    // Prepare allowed_ips payload
    let allowedIpsPayload = '';
    if (ipRestrictionEnabled && allowedIps) {
      // Convert newlines to commas, trim whitespace
      const ips = allowedIps
        .split(/[\n,]/)
        .map(ip => ip.trim())
        .filter(ip => ip);

      // Deduplicate IPs
      const uniqueIps = [...new Set(ips)];
      allowedIpsPayload = uniqueIps.join(',');
    }

    if (
      tenantId === originalTenantId &&
      tenantName === originalTenantName &&
      scheduleTool === originalScheduleTool &&
      allowedIpsPayload === originalAllowedIps &&
      isPasswordLogin === originalIsPasswordLogin
    ) {
      return null;
    }

    return {
      values: [
        {
          name: tenantName,
          schedule_tool: scheduleTool,
          allowed_ips: allowedIpsPayload,
          is_password_login: isPasswordLogin,
        },
      ],
    };
  };

  getAuthProviderInfoPayload = ({ data }) => {
    const { originalFormValues } = this.state;
    const {
      authProviderId: originalAuthProviderId,
      authProvider: originalAthProvider,
      azureTenantId: originalAzureTenantId,
      azureClientId: originalAzureClientId,
      azureClientSecret: originalAzureClientSecret,
    } = originalFormValues;

    const {
      authProviderId,
      authProvider,
      azureTenantId,
      azureClientId,
      azureClientSecret,
    } = data;
    if (
      (authProviderId === originalAuthProviderId &&
        authProvider === originalAthProvider &&
        authProvider === 'none') ||
      (authProviderId === originalAuthProviderId &&
        authProvider === originalAthProvider &&
        azureTenantId === originalAzureTenantId &&
        azureClientId === originalAzureClientId &&
        azureClientSecret === originalAzureClientSecret)
    ) {
      return null;
    }

    let value = {
      auth_provider_id: authProviderId ?? null,
      auth_provider: authProvider !== 'none' ? authProvider : null,
    };

    if (value.auth_provider !== null) {
      value.azure_tenant_id = azureTenantId;
      value.azure_client_id = azureClientId;
      value.azure_client_secret = azureClientSecret;
    }

    return {
      values: [value],
    };
  };

  transformPayloadKeyField = ({ data, type, changedFields }) => {
    const result = {};
    let fieldList = [];
    switch (type) {
      case API_KEY_PRODUCT_TYPE.MERAKI:
        fieldList = [...this.merakiFieldList];
        break;
      case API_KEY_PRODUCT_TYPE.VERKADA:
        fieldList = [...this.verkadaFieldList];
        break;
      case API_KEY_PRODUCT_TYPE.MICROSOFT_OFFICE:
        fieldList = [...this.microsoftOfficeFieldList];
        break;
      case API_KEY_PRODUCT_TYPE.MICROSOFT_TEAMS:
        fieldList = [...this.microsoftTeamsFieldList];
        break;
      case API_KEY_PRODUCT_TYPE.BUTLR:
        fieldList = [...this.butlrFieldList];
        break;
      case API_KEY_PRODUCT_TYPE.SLACK:
        fieldList = [...this.slackFieldList];
        break;
      case API_KEY_PRODUCT_TYPE.ARUBA:
        fieldList = [...this.arubaFieldList];
        break;
      case API_KEY_PRODUCT_TYPE.GAROON:
        fieldList = [...this.garoonFieldList];
        break;
      case API_KEY_PRODUCT_TYPE.WEBEX:
        fieldList = [...this.webexFieldList];
        break;
      case API_KEY_PRODUCT_TYPE.GOOGLE:
        fieldList = [...this.googleFieldList];
        break;
      default:
        break;
    }
    fieldList.forEach(item => {
      const { key, respondKey, payloadKey } = item;
      if (changedFields.length > 0 && !changedFields.includes(key)) {
        return;
      }
      if (payloadKey) {
        result[payloadKey] = data[key] ?? null;
      } else {
        result[respondKey] = data[key] ?? null;
      }
    });
    return result;
  };

  convertToPayload = ({ data, fieldList, type }) => {
    const { originalFormValues } = this.state;
    let currentData = {};
    const keyId = `${type}ApiKeyId`;
    let prevData = {};
    let isDataChanged = false;
    let isAllFieldNull = true;
    const changedFields = [];
    fieldList.forEach(item => {
      const { key } = item;
      currentData[key] = data[key];
      prevData[key] = originalFormValues[key];
      isDataChanged =
        isDataChanged || !isEqual(currentData[key], prevData[key]);
      if (!isEqual(currentData[key], prevData[key])) {
        changedFields.push(key);
      }
      isAllFieldNull = isAllFieldNull && isNull(currentData[key]);
    });
    const id = data[keyId];
    const prevId = originalFormValues[keyId];
    let payload = null;
    const isCreated = isNil(id) && isNil(prevId) && isDataChanged;
    const isDeleted = id > 0 && prevId > 0 && isAllFieldNull;
    const isChanged =
      id > 0 && id === prevId && !isAllFieldNull && isDataChanged;
    if (isDeleted) {
      // Delete
      payload = {
        id: id,
        key: null,
      };
    } else if (isChanged || isCreated) {
      // Update or Add
      const transformData = this.transformPayloadKeyField({
        data: currentData,
        type,
        changedFields: changedFields,
      });
      payload = {
        id: isNil(id) ? null : id,
        product: type,
        ...transformData,
      };
    } else {
      // No change
    }
    return payload;
  };

  convertApiKeysInfoPayload = ({ data }) => {
    let apiKeyPayload = {
      values: [],
    };
    // filter data that is change on data comparing to originalFormValues
    const merakiPayload = this.convertToPayload({
      data,
      fieldList: this.merakiFieldList,
      type: API_KEY_PRODUCT_TYPE.MERAKI,
    });
    if (merakiPayload) {
      apiKeyPayload = {
        ...apiKeyPayload,
        values: [...apiKeyPayload.values, merakiPayload],
      };
    }

    const verkadaPayload = this.convertToPayload({
      data,
      fieldList: this.verkadaFieldList,
      type: API_KEY_PRODUCT_TYPE.VERKADA,
    });
    if (verkadaPayload) {
      apiKeyPayload = {
        ...apiKeyPayload,
        values: [...apiKeyPayload.values, verkadaPayload],
      };
    }

    const microsoftPayload = this.convertToPayload({
      data,
      fieldList: this.microsoftOfficeFieldList,
      type: API_KEY_PRODUCT_TYPE.MICROSOFT_OFFICE,
    });
    if (microsoftPayload) {
      apiKeyPayload = {
        ...apiKeyPayload,
        values: [...apiKeyPayload.values, microsoftPayload],
      };
    }

    const microsoftTeamsPayload = this.convertToPayload({
      data,
      fieldList: this.microsoftTeamsFieldList,
      type: API_KEY_PRODUCT_TYPE.MICROSOFT_TEAMS,
    });
    if (microsoftTeamsPayload) {
      apiKeyPayload = {
        ...apiKeyPayload,
        values: [...apiKeyPayload.values, microsoftTeamsPayload],
      };
    }

    const butlrPayload = this.convertToPayload({
      data,
      fieldList: this.butlrFieldList,
      type: API_KEY_PRODUCT_TYPE.BUTLR,
    });
    if (butlrPayload) {
      apiKeyPayload = {
        ...apiKeyPayload,
        values: [...apiKeyPayload.values, butlrPayload],
      };
    }

    const slackPayload = this.convertToPayload({
      data,
      fieldList: this.slackFieldList,
      type: API_KEY_PRODUCT_TYPE.SLACK,
    });
    if (slackPayload) {
      apiKeyPayload = {
        ...apiKeyPayload,
        values: [...apiKeyPayload.values, slackPayload],
      };
    }

    const arubaPayload = this.convertToPayload({
      data,
      fieldList: this.arubaFieldList,
      type: API_KEY_PRODUCT_TYPE.ARUBA,
    });
    if (arubaPayload) {
      apiKeyPayload = {
        ...apiKeyPayload,
        values: [...apiKeyPayload.values, arubaPayload],
      };
    }

    const garoonPayload = this.convertToPayload({
      data,
      fieldList: this.garoonFieldList,
      type: API_KEY_PRODUCT_TYPE.GAROON,
    });
    if (garoonPayload) {
      apiKeyPayload = {
        ...apiKeyPayload,
        values: [...apiKeyPayload.values, garoonPayload],
      };
    }

    const webexPayload = this.convertToPayload({
      data,
      fieldList: this.webexFieldList,
      type: API_KEY_PRODUCT_TYPE.WEBEX,
    });
    if (webexPayload) {
      apiKeyPayload = {
        ...apiKeyPayload,
        values: [...apiKeyPayload.values, webexPayload],
      };
    }

    const googlePayload = this.convertToPayload({
      data,
      fieldList: this.googleFieldList,
      type: API_KEY_PRODUCT_TYPE.GOOGLE,
    });
    if (googlePayload) {
      apiKeyPayload = {
        ...apiKeyPayload,
        values: [...apiKeyPayload.values, googlePayload],
      };
    }

    if (apiKeyPayload.values.length === 0) {
      return null;
    }
    return apiKeyPayload;
  };

  updateData = async ({ data }) => {
    const tenantPayload = this.getTenantInfoPayload({ data });
    const apiKeyPayload = this.convertApiKeysInfoPayload({ data });
    const authProviderPayload = this.getAuthProviderInfoPayload({ data });
    if (
      tenantPayload == null &&
      apiKeyPayload == null &&
      authProviderPayload == null
    ) {
      // nothing to update
      this.toastRef.current.show({
        severity: 'info',
        summary: '情報',
        detail: COMMON_TEXT.NO_CHANGE_TO_BE_SAVED,
        life: 3000,
        closable: true,
      });
      return;
    }
    this.setState({ isUpdating: true });
    let isSuccessTenant = null;
    let isSuccessApiKey = null;
    let isSuccessAuthProvider = null;

    if (!isNull(tenantPayload)) {
      const { isSuccess } = await this.updateTenantInfo({ tenantPayload });
      isSuccessTenant = isSuccess;
    }
    if (!isNull(apiKeyPayload)) {
      const { isSuccess } = await this.updateApiKeysInfo({ apiKeyPayload });
      isSuccessApiKey = isSuccess;
    }

    if (!isNull(authProviderPayload)) {
      const { isSuccess } = await this.updateAuthProviderInfo({ authProviderPayload });
      isSuccessAuthProvider = isSuccess;
    }

    if (
      (isSuccessTenant && isSuccessApiKey && isSuccessAuthProvider) ||
      isSuccessTenant ||
      isSuccessApiKey ||
      isSuccessAuthProvider
    ) {
      this.setState({ isUpdating: false }, () => {
        Toaster.success(COMMON_TEXT.SAVED_SUCCESSFULLY);
        this.getData();
      });
    } else {
      this.setState({ isUpdating: false }, () => {
        Toaster.error(COMMON_TEXT.SAVE_FAILED);
      });
    }
  };

  renderSettingContent() {
    const { isLoading, initialFormValues } = this.state;

    const isFormFieldInvalid = (type, touched, errors) => {
      return touched[type] && errors[type] ? 'p-invalid' : '';
    };

    const handleSubmit = (values, { setSubmitting, errors }) => {
      if (!errors) {
        this.updateData({ data: values });
      } else {
      }
    };

    const getFormErrorMessage = (name, errors, touched) => {
      return isFormFieldInvalid(name, touched, errors) ? (
        <span className="validation-error-message">{errors[name]}</span>
      ) : (
        <></>
      );
    };

    const handleChangeInput = ({ type, values }) => {
      values[type] = '';
      this.setState({
        initialFormValues: {
          ...values,
        },
      });
    };

    const renderInputField = ({
      values,
      handleChange,
      touched,
      errors,
      fieldList,
    }) => {
      const deleteAccepted = ({ values }) => {
        const fieldObj = {};
        fieldList.forEach(item => {
          const { key } = item;
          fieldObj[key] = null;
        });
        const newInitialFormValues = {
          ...values,
          ...fieldObj,
        };
        this.setState({
          initialFormValues: newInitialFormValues,
        });
      };

      const deleteButtonOnClicked = ({ values }) => {
        const isAllEmpty = fieldList.every(
          item => isEmpty(values[item.key]) || isNil(values[item.key])
        );
        if (!isAllEmpty) {
          confirmDialog({
            id: `delete-api-key-confirm-dialog-microsoft`,
            message: COMMON_TEXT.DELETE_CONFIRM_MESSAGE,
            header: 'APIキーの削除',
            icon: '',
            accept: () => deleteAccepted({ values }),
            reject: () => { },
            acceptClassName: 'p-button-danger',
            rejectClassName: 'p-button-secondary p-button-text',
            appendTo: 'self',
          });
        } else {
          deleteAccepted({ values });
        }
      };

      const addButtonOnClicked = ({ values }) => {
        const fieldObj = {};
        fieldList.forEach(item => {
          const { key } = item;
          fieldObj[key] = '';
        });
        const newInitialFormValues = {
          ...values,
          ...fieldObj,
        };
        this.setState({
          initialFormValues: newInitialFormValues,
        });
      };

      const secretFieldOnClicked = ({ keyItem }) => {
        const fieldObj = {};

        fieldList.forEach(item => {
          const { key } = item;
          if (key === keyItem) {
            fieldObj[key] = '';
          }
        });

        const newInitialFormValues = {
          ...values,
          ...fieldObj,
        };

        this.setState({
          initialFormValues: newInitialFormValues,
        });
      };

      const hasSomeValue = fieldList.some(item => !isNil(values[item.key]));
      return (
        <>
          {hasSomeValue ? (
            <>
              {fieldList.map((item, index) => {
                const { key, title, isMasked } = item;
                return (
                  <div
                    className={`input-text-field-container ${key}`}
                    key={`container-${key}-${index}`}
                  >
                    <span className="input-top-title">{title}</span>
                    {isMasked ? (
                      <Password
                        inputId={key}
                        feedback={false}
                        value={values[`${key}`]}
                        onChange={e => handleChange(e)}
                        onClick={e => {
                          secretFieldOnClicked({ keyItem: key });
                          // handleClickField({ keyItem: key });
                        }}
                        className={isFormFieldInvalid(key, touched, errors)}
                      />
                    ) : (
                      <InputText
                        id={key}
                        value={values[`${key}`]}
                        onChange={e => handleChange(e)}
                        className={isFormFieldInvalid(key, touched, errors)}
                      />
                    )}
                    {getFormErrorMessage(key, errors, touched)}
                  </div>
                );
              })}
              <div className="input-text-field-container">
                <Button
                  type="button"
                  text
                  severity="danger"
                  className="icon-only-delete-button"
                  onClick={e => {
                    deleteButtonOnClicked({ values });
                  }}
                >
                  <span className="delete-icon">
                    <img src="assets/img/trash-icon.svg" alt="Delete" />
                  </span>
                </Button>
              </div>
            </>
          ) : (
            <Button
              type="button"
              severity="secondary"
              label="追加"
              className="add-button has-shadow"
              onClick={e => addButtonOnClicked({ values })}
            />
          )}
        </>
      );
    };

    const validateSchema = () => {
      const types = Object.keys(initialFormValues);
      // check if value of field is null
      const notNulltypes = types.filter(
        type => !isNull(initialFormValues[type])
      );
      // create yup schema object from not null field names
      const yupSchemaObject = {};
      notNulltypes.forEach(type => {
        switch (type) {
          case 'scheduleTool':
            break;
          case 'teamsWebhookUrl':
          case 'slackApiKey':
            // No validation required
            break;
          case 'authProviderId':
            break;
          case 'azureTenantId':
          case 'azureClientId':
          case 'azureClientSecret':
            yupSchemaObject[type] = Yup.string().when('authProvider', val => {
              if (val?.length > 0 && val[0] === 'azure') {
                return Yup.string().required(COMMON_TEXT.REQUIRED);
              } else {
                return Yup.string().notRequired();
              }
            });
            break;
          case 'ipRestrictionEnabled':
            // No validation needed for boolean
            break;
          case 'allowedIps':
            yupSchemaObject[type] = Yup.string().test(
              'valid-ip-format',
              'Invalid IP address format',
              function (value) {
                // Skip validation if IP restriction is disabled
                if (!this.parent.ipRestrictionEnabled) {
                  return true;
                }

                // If enabled but empty, show error
                if (!value || value.trim() === '') {
                  return this.createError({
                    message: 'IP制限を有効にする場合は、少なくとも1つのIPアドレスが必要です',
                  });
                }

                // Split by newline or comma
                const ips = value
                  .split(/[\n,]/)
                  .map(ip => ip.trim())
                  .filter(ip => ip);

                if (ips.length === 0) {
                  return this.createError({
                    message: '少なくとも1つのIPアドレスが必要です',
                  });
                }

                // Check for duplicates
                const uniqueIps = new Set(ips);
                if (uniqueIps.size !== ips.length) {
                  return this.createError({
                    message: 'IPアドレスは既に登録されています。',
                  });
                }

                // Helper function to validate IPv4
                const isValidIPv4 = (ip) => {
                  const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/;
                  if (!ipv4Regex.test(ip)) return false;

                  const octets = ip.split('.');
                  return octets.every(octet => {
                    const num = parseInt(octet, 10);
                    return num >= 0 && num <= 255;
                  });
                };

                // Helper function to validate IPv6
                const isValidIPv6 = (ip) => {
                  // IPv6 can be:
                  // - Full: 2001:0db8:85a3:0000:0000:8a2e:0370:7334
                  // - Compressed: 2001:db8:85a3::8a2e:370:7334
                  // - Localhost: ::1
                  // - All zeros: ::
                  const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
                  return ipv6Regex.test(ip);
                };

                // Validate each IP
                for (const ip of ips) {
                  let ipPart = ip;
                  let prefix = null;

                  // Check if CIDR notation is present
                  if (ip.includes('/')) {
                    const parts = ip.split('/');
                    ipPart = parts[0];
                    prefix = parseInt(parts[1], 10);

                    if (isNaN(prefix)) {
                      return this.createError({
                        message: `CIDRプレフィックスが無効です。プレフィックスは数字でなければなりません`,
                      });
                    }
                  }

                  // Determine if IPv4 or IPv6 and validate
                  const isIPv6 = ipPart.includes(':');

                  if (isIPv6) {
                    // IPv6 validation
                    if (!isValidIPv6(ipPart)) {
                      return this.createError({
                        message: `無効なIPv6アドレス形式です。例: 2001:db8::1 または 2001:db8::/32`,
                      });
                    }

                    // Check CIDR prefix is <= 128 for IPv6
                    if (prefix !== null && (prefix < 0 || prefix > 128)) {
                      return this.createError({
                        message: `IPv6 CIDRプレフィックスは0から128の間でなければなりません`,
                      });
                    }
                  } else {
                    // IPv4 validation
                    if (!isValidIPv4(ipPart)) {
                      return this.createError({
                        message: `無効なIPv4アドレス形式です。例: 192.168.1.0/24 または 10.0.0.1`,
                      });
                    }

                    // Check CIDR prefix is <= 32 for IPv4
                    if (prefix !== null && (prefix < 0 || prefix > 32)) {
                      return this.createError({
                        message: `IPv4 CIDRプレフィックスは0から32の間でなければなりません`,
                      });
                    }
                  }
                }

                return true;
              }
            );
            break;
          default:
            yupSchemaObject[type] = Yup.string().required(COMMON_TEXT.REQUIRED);
            break;
        }
      });
      return Yup.object(yupSchemaObject);
    };

    const rowList = [
      {
        product: 'Meraki',
        fieldList: this.merakiFieldList,
      },
      {
        product: 'Verkada',
        fieldList: this.verkadaFieldList,
      },
      {
        product: 'Microsoft Office',
        fieldList: this.microsoftOfficeFieldList,
      },
      {
        product: 'Microsoft Teams',
        fieldList: this.microsoftTeamsFieldList,
      },
      {
        product: 'Google',
        fieldList: this.googleFieldList,
      },
      {
        product: 'Butlr',
        fieldList: this.butlrFieldList,
      },
      {
        product: 'Slack',
        fieldList: this.slackFieldList,
      },
      {
        product: 'Aruba',
        fieldList: this.arubaFieldList,
      },
      {
        product: 'Garoon',
        fieldList: this.garoonFieldList,
      },
      {
        product: 'Webex',
        fieldList: this.webexFieldList,
      },
    ];

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <Formik
            initialValues={initialFormValues}
            validationSchema={validateSchema()}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ values, handleChange, handleBlur, setFieldValue, setFieldError, touched, errors }) => {
              // Update state when allowedIps errors change
              const hasIpError = Boolean(errors.allowedIps && values.ipRestrictionEnabled);
              if (hasIpError !== this.state.hasIpError) {
                // Use setTimeout to avoid setState during render
                setTimeout(() => {
                  this.setState({ hasIpError });
                }, 0);
              }

              return (
                <Form id="tenant-setting-form">
                  <div className="basic-fields-container">
                    <div className="basic-field-item tenant-name">
                      <div className="top-title">
                        <span className="figma-label-style">テナント名</span>
                      </div>
                      <div className="bottom-content">
                        <div className="input-text-field-container">
                          <InputText
                            id="tenantName"
                            value={values.tenantName}
                            onChange={e => handleChange(e)}
                            className={isFormFieldInvalid(
                              'tenantName',
                              touched,
                              errors
                            )}
                          />
                          {getFormErrorMessage('tenantName', errors, touched)}
                        </div>
                      </div>
                    </div>
                    <div className="basic-field-item schedule-tool">
                      <div className="top-title">
                        <span className="figma-label-style">{COMMON_TEXT.SCHEDULE_TOOL}</span>
                      </div>
                      <div className="bottom-content">
                        <div className="figma-dropdown">
                          <Dropdown
                            id={`scheduleTool`}
                            value={values.scheduleTool}
                            options={this.scheduleToolOptions}
                            onChange={e => handleChange(e)}
                            className={isFormFieldInvalid(
                              'scheduleTool',
                              touched,
                              errors
                            )}
                          ></Dropdown>
                          {getFormErrorMessage('scheduleTool', errors, touched)}
                        </div>
                      </div>
                    </div>
                    <div className="basic-field-item password-login">
                      <div className="top-title">
                        <span className="figma-label-style">パスワード認証</span>
                      </div>
                      <div className="bottom-content">
                        <div className="figma-dropdown">
                          <Dropdown
                            id={`isPasswordLogin`}
                            value={values.isPasswordLogin}
                            options={this.passwordLoginOptions}
                            onChange={e => handleChange(e)}
                            className={isFormFieldInvalid(
                              'isPasswordLogin',
                              touched,
                              errors
                            )}
                          ></Dropdown>
                          {getFormErrorMessage('isPasswordLogin', errors, touched)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="section-divider"></div>
                  <div className="main-row-container auth-provider-header">
                    <div className="left-title">
                      <span>APIキー・プロダクト</span>
                    </div>
                  </div>
                  <div className="main-row-container">
                    <div className="left-spacer"></div>
                    <div className="right-content">
                      {rowList.map((row, index) => {
                        const { product, fieldList } = row;
                        return (
                          <div className="row-container" key={`row-${index}`}>
                            <div className="product-field">
                              <span className="figma-label-style">{product}</span>
                            </div>
                            <div className="key-field">
                              {renderInputField({
                                values,
                                handleChange,
                                touched,
                                errors,
                                fieldList,
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="section-divider"></div>
                  <div className="main-row-container">
                    <div className="left-title">
                      <span>{COMMON_TEXT.TENANT_SIGN_ON}</span>
                    </div>
                  </div>
                  <div className="main-row-container tenant-sign-on">
                    <div className="left-spacer"></div>
                    <div className="right-content">
                      <div className="row-container">
                        <div className="product-field">
                          <span className="figma-label-style">{COMMON_TEXT.TENANT_AUTH_PROVIDER}</span>
                        </div>
                        <div className="key-field">
                          <div className="figma-dropdown">
                            <Dropdown
                              id={`authProvider`}
                              value={values.authProvider}
                              options={this.authProviderOptions}
                              onChange={e => handleChange(e)}
                              className={isFormFieldInvalid(
                                'authProvider',
                                touched,
                                errors
                              )}
                            />
                          </div>
                        </div>
                      </div>

                      {values.authProvider !== 'none' && (
                        <>
                          <div className="row-container">
                            <div className="product-field">
                              <span className="figma-label-style">{COMMON_TEXT.TENANT_AZURE_TENANT_ID}</span>
                            </div>
                            <div className="key-field">
                              <div className="input-text-field-container">
                                <InputText
                                  id="azureTenantId"
                                  value={values.azureTenantId}
                                  onChange={e => handleChange(e)}
                                  className={isFormFieldInvalid(
                                    'azureTenantId',
                                    touched,
                                    errors
                                  )}
                                />
                                {getFormErrorMessage(
                                  'azureTenantId',
                                  errors,
                                  touched
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row-container">
                            <div className="product-field">
                              <span className="figma-label-style">{COMMON_TEXT.TENANT_AZURE_CLIENT_ID}</span>
                            </div>
                            <div className="key-field">
                              <div className="input-text-field-container">
                                <InputText
                                  id="azureClientId"
                                  value={values.azureClientId}
                                  onChange={e => handleChange(e)}
                                  className={isFormFieldInvalid(
                                    'azureClientId',
                                    touched,
                                    errors
                                  )}
                                />
                                {getFormErrorMessage(
                                  'azureClientId',
                                  errors,
                                  touched
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row-container">
                            <div className="product-field">
                              <span className="figma-label-style">
                                {COMMON_TEXT.TENANT_AZURE_CLIENT_SECRET}
                              </span>
                            </div>
                            <div className="key-field">
                              <div className="input-text-field-container">
                                <Password
                                  inputId={'azureClientSecret'}
                                  feedback={false}
                                  value={values.azureClientSecret}
                                  onChange={e => handleChange(e)}
                                  onClick={() => {
                                    handleChangeInput({
                                      type: 'azureClientSecret',
                                      values,
                                    });
                                  }}
                                  className={isFormFieldInvalid(
                                    'azureClientSecret',
                                    touched,
                                    errors
                                  )}
                                />
                                {getFormErrorMessage(
                                  'azureClientSecret',
                                  errors,
                                  touched
                                )}
                              </div>
                            </div>
                          </div>

                          {values.authProvider === 'azure' && values.authProviderId && (
                            <div className="row-container">
                              <div className="product-field">
                                <span className="figma-label-style">
                                  ログインURL
                                </span>
                              </div>
                              <div className="key-field">
                                <div className="input-text-field-container">
                                  <div className="login-url-display">
                                    <span className="login-url-text">
                                      {window.location.origin}/login/provider/{values.authProvider}-{values.authProviderId}
                                    </span>
                                    <button
                                      type="button"
                                      className="copy-url-button"
                                      onClick={() => {
                                        navigator.clipboard.writeText(
                                          `${window.location.origin}/login/provider/${values.authProvider}-${values.authProviderId}`
                                        );
                                        Toaster.success('URLをコピーしました');
                                      }}
                                    >
                                      Copy
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>

                  {/* Login Control Section */}
                  <div className="section-divider"></div>
                  <div className="main-row-container">
                    <div className="left-title">
                      <span>ログイン制御</span>
                    </div>
                  </div>
                  <div className="main-row-container login-control-section">
                    <div className="left-spacer"></div>
                    <div className="right-content">
                      {/* IP Address Restriction Toggle */}
                      <div className="row-container">
                        <div className="product-field">
                          <span className="figma-label-style">IPアドレス制限</span>
                          <div className="radio-group-horizontal">
                            <div className="radio-option">
                              <RadioButton
                                inputId="ip-restriction-disabled"
                                name="ipRestrictionEnabled"
                                value={false}
                                checked={!values.ipRestrictionEnabled}
                                onChange={() => {
                                  setFieldValue('ipRestrictionEnabled', false);
                                  setFieldError('allowedIps', undefined);
                                }}
                              />
                              <label htmlFor="ip-restriction-disabled" className="radio-label">
                                無効
                              </label>
                            </div>
                            <div className="radio-option">
                              <RadioButton
                                inputId="ip-restriction-enabled"
                                name="ipRestrictionEnabled"
                                value={true}
                                checked={values.ipRestrictionEnabled}
                                onChange={() => setFieldValue('ipRestrictionEnabled', true)}
                              />
                              <label htmlFor="ip-restriction-enabled" className="radio-label">
                                有効
                              </label>
                            </div>
                          </div>
                        </div>

                        {/* IP Address Textarea (shown only when enabled) */}
                        {values.ipRestrictionEnabled && (
                          <div className="key-field">
                            <div className="input-text-field-container allowed-ips-container">
                              <InputTextarea
                                id="allowedIps"
                                name="allowedIps"
                                value={values.allowedIps || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                rows={5}
                                className={errors.allowedIps && values.ipRestrictionEnabled ? 'p-invalid' : ''}
                              />
                            </div>
                            <div>
                              {errors.allowedIps && values.ipRestrictionEnabled && (
                                <small className="p-error">{errors.allowedIps}</small>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        )}
      </>
    );
  }

  render() {
    return (
      <>
        <Toast ref={this.toastRef} position="top-center" />
        <ConfirmDialog />
        <div className="config-container custom-config-container tenant-setting-container custom-setting-config-container">
          <div className="config-title-container">
            <div className="text-left">
              <div className="title-text">{COMMON_TEXT.TENANT_SETTING}</div>
            </div>
            <div className="grid grid-nogutter align-items-center justify-content-end">
              <SaveButton
                type="submit"
                loading={this.state.isUpdating}
                disabled={this.state.hasIpError}
                form="tenant-setting-form"
                label="保存"
                iconSrc="assets/img/save-setting-icon.svg"
                iconAlt="Save"
              />
            </div>
          </div>
          <div className="config-content">
            <div className="setting-content">{this.renderSettingContent()}</div>
          </div>
        </div>
      </>
    );
  }
}

TenantSetting.propTypes = {};

export default TenantSetting;
